(function () {
  const config = {
    id: 'jsm-chat-widget',
    'jira-id': 'a8985096-c130-33c9-8fa2-5ad2c56bf302',
    'service-desk-id': '18'
  };

  function loadChatWidget() {
    const script = document.createElement('script');
    script.src = 'https://cdn.chat.appfire.app/app/widget-prod/get-chat.min.js';
    script.defer = true;
    script.onerror = function () {
      console.error('Failed to load dev chat widget script');
    };

    document.head.appendChild(script);
  }

  function initializeChatWidget() {
    const chatWidget = document.createElement('chat-widget');
    chatWidget.setAttribute('auto-show', 'false');
    chatWidget.setAttribute('id', config.id);
    chatWidget.setAttribute('jira-id', config['jira-id']);
    chatWidget.setAttribute('service-desk-id', config['service-desk-id']);

    document.body.appendChild(chatWidget);
  }

  loadChatWidget();
  initializeChatWidget();
})();
